import React from 'react';
import './InfoCardContent.css';

function InfoCardContent(items) {
    return (<ul className="info-card-content">
        {items.map( (item, index) => (index === 0) ? 
        <li className="bold-element info-card-content-item" key={index}>
            <i className="fa fa-angle-right" />
            {item}
        </li> : 
        <li className="info-card-content-item" key={index}>
            <i className="fa fa-angle-right" />
            {item}
        </li>)}
    </ul>)
}

export default InfoCardContent;